import { Controller } from "@hotwired/stimulus"

// Phase 2.5 Tier 3 — Scoring Rubric form. Live-validates that the
// criterion weights sum to 1.0 (100%) as the admin types, and supports
// add / remove of criterion rows via a `<template>` block + child_index
// nested-attributes pattern.
export default class extends Controller {
  static targets = ["rows", "weight", "weightSum", "rowTemplate", "row", "destroyFlag"]

  connect() {
    this._templateIndex = Date.now()
    this.updateSum()
  }

  updateSum() {
    if (!this.hasWeightSumTarget) return
    const sum = this.weightTargets.reduce((acc, el) => {
      const row = el.closest("[data-scoring-rubric-form-target='row']")
      if (!row || row.classList.contains("hidden")) return acc
      return acc + parseFloat(el.value || "0")
    }, 0)
    const pct = (sum * 100)
    this.weightSumTarget.textContent = pct.toFixed(0)
    const close = Math.abs(sum - 1.0) < 0.005
    this.weightSumTarget.classList.toggle("text-emerald-700", close)
    this.weightSumTarget.classList.toggle("text-rose-600", !close)
  }

  addRow() {
    if (!this.hasRowTemplateTarget) return
    const html = this.rowTemplateTarget.innerHTML
      .replace(/TEMPLATE_INDEX/g, this._templateIndex)
    this._templateIndex += 1
    const wrapper = document.createElement("div")
    wrapper.innerHTML = html.trim()
    while (wrapper.firstChild) {
      this.rowsTarget.appendChild(wrapper.firstChild)
    }
    this.updateSum()
  }

  removeRow(event) {
    const row = event.target.closest("[data-scoring-rubric-form-target='row']")
    if (!row) return

    // For persisted rows, set the _destroy flag and hide instead of
    // removing — Rails nested-attributes processes _destroy on submit.
    const idInput = row.querySelector('input[name*="[id]"]')
    const destroyInput = row.querySelector('input[name*="[_destroy]"]')
    if (idInput && idInput.value && destroyInput) {
      destroyInput.value = "1"
      row.classList.add("hidden")
    } else {
      row.remove()
    }
    this.updateSum()
  }
}
